<ssc-app-layout [showFooterContactButton]="true" containerSize="small">
  <ssc-header [hasBasket]="false" [hasStepper]="false"></ssc-header>

  <h1 *ngIf="basicInsuranceProduct === 'VIVA'; else defaultTitle" class="headline-1">
    {{ 'CAMPAIGN.TITLE.VIVA' | translate }}
  </h1>
  <ng-template #defaultTitle
    ><h1 class="headline-1">
      {{ 'CAMPAIGN.TITLE.VISANA' | translate }}
    </h1></ng-template
  >
  <p class="body-1 campaign-description">
    {{ 'CAMPAIGN.DESCRIPTION' | translate }}
  </p>
  <form class="form" [dapLibScrollToError]="scrollToErrorEventEmitter">
    <ssc-person-data
      [index]="0"
      [showHeader]="false"
      [showNameField]="false"
      [personFormGroup]="personFormGroup()"
      [validateForm]="showValidations"
    ></ssc-person-data>

    <ssc-zip-code-autocomplete
      [formControl]="formGroup.controls.address"
      [validateForm]="showValidations"
      [saleOfferBegin]="formGroup.controls.saleOfferBegin"
    ></ssc-zip-code-autocomplete>

    <ng-container *ngIf="basicInsuranceSelected">
      <ssc-coverage-selection
        (accidentCoverageSelected)="onAccidentCoverageSelected($event)"
        (franchiseSelected)="onFranchiseSelected($event)"
        [initialAccidentCoverage]="includesAccidentCoverage"
        [initialFranchise]="franchise"
      ></ssc-coverage-selection>
    </ng-container>
  </form>
  <div class="action-container">
    <dap-lib-button
      class="stretch"
      (click)="tryUpdateStoreAndNavigate()"
      [variant]="'primary'"
      [buttonSize]="'large'"
      data-cy="button-show-prices"
      data-analytics="key-data_navigate-to-products"
      >{{ 'CAMPAIGN.NAVIGATION.SHOW_PRICES' | translate }}</dap-lib-button
    >
  </div>
</ssc-app-layout>
